import React from 'react';
import styled from 'styled-components';

import NavItem from './NavItem/NavItem';

const Nav = styled.nav`
`
const NavList = styled.ul`
    display: flex;
    flex-direction: ${props => (props.mobile ? 'column' : 'row')};
    align-items: center;
    height: 100%;
`

const NavItems = ({ mobile, clicked }) => {
    return (
        <Nav>
            <NavList mobile={mobile}>
                <NavItem link="/" clicked={clicked} mobile={mobile}>Welkom</NavItem>
                <NavItem link="/shop" clicked={clicked} mobile={mobile}>Aanbod</NavItem>
                <NavItem link="/contact" clicked={clicked} mobile={mobile}>Contact</NavItem>
            </NavList>
        </Nav>
    )
};

export default NavItems;